import axios from "axios";
import { SERVER_BASE_URL } from "./index";
import { message } from "antd";

const API = axios.create({
  baseURL: SERVER_BASE_URL,
  withCredentials: true, // Send cookies for refresh token
});

// Request Interceptor: Add access token
API.interceptors.request.use(
  (config) => {
    const jwt_access_token = localStorage.getItem("jwt_access_token");
    if (jwt_access_token) {
      config.headers.Authorization = `Bearer ${jwt_access_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle token refresh
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const isRefreshExpired =
      error?.response?.data?.message ===
        "Refresh token: Authentication failure!" &&
      error?.response?.data?.error_msg === "jwt expired";

    if (isRefreshExpired) {
      message.error("Session Expired. Please login again!");
      localStorage.removeItem("jwt_access_token");
      window.location.replace("#/login");
      return Promise.reject(error);
    }

    if (
      error.response?.status !== 401 ||
      originalRequest._retry ||
      error.response?.data?.message !== "Authentication failure!"
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      const newAccessToken = await refreshToken();
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
      return API(originalRequest);
    } catch (refreshError) {
      message.error("Session Expired. Please login again!");
      localStorage.removeItem("jwt_access_token");
      window.location.replace("#/login");
      return Promise.reject(refreshError);
    }
  }
);

// Refresh Token API
const refreshToken = async () => {
  const response = await API.post("/auth/refresh_token");

  const jwt_access_token = response?.data?.data?.access_token;

  if (jwt_access_token) {
    localStorage.setItem("jwt_access_token", jwt_access_token);
    return jwt_access_token;
  }

  throw new Error("No access token returned from refresh");
};

export { API, refreshToken };
